import React from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'material-ui';
import { onCheckSyncSection } from '../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import R from 'ramda';

const SyncSectionCheckbox = ({ sectionInEdit, label, style, labelStyle, onCheck, syncedSectionsImmu }) => {
  const syncedSections = syncedSectionsImmu ? syncedSectionsImmu.toJS() : [];
  return (<Checkbox
    label={label || 'Sync to Other Products'}
    style={style}
    labelStyle={labelStyle}
    checked={R.contains(sectionInEdit, syncedSections)}
    onCheck={(_, inputChecked) => onCheck(sectionInEdit, inputChecked)}
  />);
};
const mapStateToProps = ({ contracting }) => ({
  syncedSectionsImmu: contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections']),
});
const mapDispatchToProps = dispatch => ({
  onCheck: (...args) => dispatch(onCheckSyncSection(...args)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SyncSectionCheckbox);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/sync-section-checkbox.jsx